import EditPnmModalContainer from './EditPnmModalContainer';

export default EditPnmModalContainer;
